import { useMemo, useState } from "react";
import { WithAuth } from "@/hoc";
import { ReportType } from "@/models";
import { Button, Card, PageHeading } from "barte-design-system";
import { GenerateReportModal } from "./_GenerateReportModal";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./relatorios.module.css";

const Relatorios = () => {
    const [user] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("barte-user-info") ?? "{}");
        } catch {
            return {};
        }
    });
    const idCompany = useMemo(() => Number(user?.companyId), [user]);
    const reportsType = useMemo<ReportType[]>(() => [
        ...((user?.roles?.includes("SELLER_ADMIN") || user?.roles?.includes("SELLER_REPORTS")) ? [
            {
                id: 1,
                title: "Vendas",
                description: "Nesse relatório você encontra todos os pagamentos que recebeu pela Barte",
                button: { title: "Gerar relatório" },
                query_file: "cobrancas-completo",
            },
            {
                id: 3,
                title: "Repasses",
                description: "Nesse relatório você encontra os saques feitos pela sua conta",
                button: { title: "Gerar relatório" },
                query_file: "report-transfers-full",
            },
            {
                id: 5,
                title: "Links de Pagamento",
                description: "Nesse relatório você encontra todos os Links de pagamento feitos pela sua conta",
                button: { title: "Gerar relatório" },
                query_file: "links-de-pagamento",
            },
            {
                id: 6,
                title: "Balanço",
                description: "Nesse relatório você encontra o balanço da sua conta",
                button: { title: "Gerar relatório" },
                query_file: "balance",
            },
            {
                id: 7,
                title: "Chargeback",
                description: "Nesse relatório você encontra todos os chargebacks que você recebeu",
                button: { title: "Gerar relatório" },
                query_file: "chargeback",
            },
            {
                id: 10,
                title: "Extrato de faturamento detalhado",
                description: "Nesse relatório você encontra o detalhamento de taxas e comissões por cobrança, com breakdown de markup, parceiro e Barte",
                button: { title: "Gerar relatório" },
                query_file: "tax_commissions",
            },
            {
                id: 8,
                title: "Extrato",
                description: "Nesse relatório você encontra o extrato da sua conta",
                button: { title: "Gerar relatório" },
                query_file: "statements",
            },
        ] : []),
        ...((user?.roles?.includes("BANKING_ADMIN") || user?.roles?.includes("BANKING_REPORT")) ? [
            {
                id: 9,
                title: "Extrato de contas",
                description: "Relatório com o extrato detalhado das movimentações financeiras das suas contas.",
                button: { title: "Gerar relatório" },
                query_file: "banking_account_statement",
            },
        ] : []),
    ], [user]);

    const [selectedReportType, setSelectedReportType] = useState<ReportType | null>(null);

    return (
        <div className={styles.container}>
            <PageHeading title="Relatórios" />
            <div className={styles.grid}>
                {/* idCompany === 1 is a UX filter only. Server-side enforcement is handled
                    by the N8N tax_commissions webhook, which validates company authorization
                    from the JWT before dispatching. */}
                {reportsType.filter((rt) => !rt.hidden && (rt.query_file !== 'tax_commissions' || idCompany === 1)).map((rt) => (
                    <Card
                        key={rt.id}
                        className={styles.card}
                        actions={
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={() => setSelectedReportType(rt)}
                            >
                                {rt.button.title}
                            </Button>
                        }
                    >
                        <strong className={styles.cardTitle}>{rt.title}</strong>
                        <p className={styles.cardDescription}>{rt.description}</p>
                    </Card>
                ))}
            </div>
            <GenerateReportModal
                isOpen={!!selectedReportType}
                onClose={() => setSelectedReportType(null)}
                onCloseSuccess={() => setSelectedReportType(null)}
                reportType={selectedReportType}
            />
        </div>
    );
};

export default WithAuth(Relatorios);
